import React, {FC} from 'react';
import {formatDateUtcToLocalDate} from '../../../utils/formFormatterUtils';

type Props = {
  date: string;
}

const UtcToLocalDate:FC<Props> = ({date}) => <>{formatDateUtcToLocalDate(date).toString()}</>

export default UtcToLocalDate;